import React, { useEffect } from 'react';

import { useNavigate } from "react-router-dom";

import { Container, Box, Button } from '@mui/material';
import { usePresence } from 'framer-motion';
import { useAppCommands } from '../appCore/AppRuntimeReact';
const Login: React.FC = () => {  
    
  const navigate = useNavigate();
  const { requestLogin } = useAppCommands();

    const [, safeToRemove] = usePresence();
    useEffect(() => {
        if(safeToRemove) safeToRemove();   
        
    }, [safeToRemove]);

  return (
    <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>        
          <Box sx={{ width: '25%', minWidth: '200px', maxWidth: '800px', height: 'auto', position: 'relative', marginTop: '10%' }}>
            <img src='/logo_tag.png' alt='In House logo' style={{ width: '100%', height: 'auto' }} />
            <Button
              style={{ width: '95%', marginTop: '20%' }}              
              color='primary'
              variant="contained"
              onClick={() => {
                void requestLogin({
                  returnTo: window.location.href,
                  redirectUri: `${window.location.origin}${window.location.pathname}`,
                });
              }} >                
              Log in
            </Button>
            <Button
              style={{ width: '95%', marginTop: '10px' }}              
              color='primary'
              onClick={() => navigate('/getsignedup')}  >             
              Sign Up
            </Button>
          </Box>
      </Container>
  );
};

export default Login;
